import { useCallback, useEffect, useState } from 'react';

/** How long the names stay shown — the Clients list's own 60 s (`pages/clients/list.tsx`). */
export const CLIENT_NAMES_SHOWN_MS = 1000 * 60;

export type ClientNamesVisibility = {
  /** True while the names are readable; false (the default) is the grey bar. */
  visible: boolean;
  toggle: () => void;
};

/**
 * Q-mt-3 A (founder, 2026-10-03): on every portal page that lists several clients, names are hidden
 * EXACTLY like the Clients list — hidden by default (a therapist sharing the screen in a telehealth
 * session must not expose other clients' names), revealed by one "Show names" press for the whole page,
 * hidden again by themselves after 60 s, and on leaving the page (the state lives in the page's own
 * render, is never stored). The timer is the Clients list's, copied.
 */
export const useClientNamesVisibility = (): ClientNamesVisibility => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!visible) return;
    const handle = setTimeout(() => setVisible(false), CLIENT_NAMES_SHOWN_MS);
    return () => clearTimeout(handle);
  }, [visible]);

  const toggle = useCallback(() => setVisible((v) => !v), []);
  return { visible, toggle };
};
